import type { RouteObject } from "react-router"

export const scopesRoutes: RouteObject[] = [
  {
    path: "scopes",
    lazy: () => import("./scopes-page").then((m) => ({ Component: m.ScopesPage })),
  },
]
